module.exports = __webpack_public_path__ + "img/Button-1.54a4a5a5.png";